import(/* webpackMode: "eager", webpackExports: ["BelowFoldBands"] */ "/vercel/path0/components/showcase/BelowFoldBands.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["ContestDateTime"] */ "/vercel/path0/features/contests/components/ContestDateTime.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/features/contests/components/HostContestLink.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/features/judge/components/home/arena/arena.module.css");
;
import(/* webpackMode: "eager", webpackExports: ["BilingualStatement"] */ "/vercel/path0/features/judge/components/home/arena/BilingualStatement.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["ContestZoneNote"] */ "/vercel/path0/features/judge/components/home/arena/ContestZoneNote.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["JudgeConsole"] */ "/vercel/path0/features/judge/components/home/arena/JudgeConsole.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/features/judge/components/home/arena/Reveal.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["RoundCountdown"] */ "/vercel/path0/features/judge/components/home/arena/RoundCountdown.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["SampleStandings"] */ "/vercel/path0/features/judge/components/home/arena/SampleStandings.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["ToolchainTicker"] */ "/vercel/path0/features/judge/components/home/arena/ToolchainTicker.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["JudgeUpcomingContests"] */ "/vercel/path0/features/judge/components/home/JudgeUpcomingContests.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/next/dist/client/app-dir/link.js");
;
import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/next/dist/client/image-component.js");
;
import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/next/font/google/target.css?{\"path\":\"features/judge/components/home/arena/arena-font.ts\",\"import\":\"JetBrains_Mono\",\"arguments\":[{\"subsets\":[\"latin\"],\"weight\":[\"400\",\"700\"],\"display\":\"swap\",\"preload\":false,\"variable\":\"--font-judge-mono\"}],\"variableName\":\"judgeMono\"}");
